module.exports = __webpack_public_path__ + "img/dark-theme-background.e949995.png";